const sansFamily = "[font-family:Inter,ui-sans-serif,system-ui,sans-serif]"
const monoFamily = "[font-family:ui-monospace,SFMono,Menlo,monospace]"
export const focusRing =
  "focus-visible:outline-none focus-visible:ring-0 focus-visible:shadow-[0_0_0_2px_#ffffff,0_0_0_4px_oklch(57.61%_0.251_258.23)]"
const darkControl =
  "cursor-pointer shadow-none transition-colors duration-100 hover:bg-[#2a2a2a] active:translate-y-0 active:shadow-none"

export const pageRootClass = `box-border w-full max-w-[1400px] bg-[#FAFAFA] px-6 pb-6 text-left font-normal text-[#171717] ml-0 mr-0 ${sansFamily}`

export const contentColumnClass =
  "flex w-full max-w-[1200px] flex-col items-start gap-24 text-left ml-0 mr-0 lg:gap-60"

export const sectionClass = "flex w-full flex-col items-start gap-6"

export const h1Class =
  "text-[64px] font-normal leading-[64px] tracking-[-0.06em] text-[#171717] max-md:text-[40px] max-md:leading-[40px]"

export const h2Class =
  "text-[56px] font-normal leading-[56px] tracking-[-0.06em] text-[#171717]"

export const leadClass =
  "text-[24px] font-normal leading-[32px] tracking-[-0.04em] text-[#4D4D4D]"

export const bodyClass = "text-[16px] font-normal leading-6 text-[#171717]"

export const primaryButtonClass = `inline-flex h-10 w-fit items-center rounded-full bg-[#171717] px-3 text-[16px] font-medium leading-6 text-white ${darkControl} ${focusRing}`

export const formButtonClass = `inline-flex h-9 w-fit items-center self-start rounded-full bg-[#171717] px-3 text-[14px] font-medium leading-5 text-white ${darkControl} ${focusRing}`

export const fieldLabelClass = "text-[16px] font-normal leading-6 text-[#171717]"

export const fieldInputClass = `h-9 rounded-[6px] border-0 bg-white px-3 text-[14px] text-[#000000] shadow-[0_0_0_1px_rgba(0,0,0,0.08)] placeholder:text-[#8F8F8F] ${focusRing}`

export const fieldInputErrorClass =
  "border-0 bg-white shadow-[0_0_0_1px_#E00000,0_0_0_5px_#F7D4D6]"

export const fieldErrorTextClass = "text-[14px] font-normal leading-5 text-[#E00000]"

export const badgeClass =
  "inline-flex items-center rounded-full border-0 bg-transparent px-2 py-[2px] text-[11px] font-medium leading-5 tracking-[0.2px] text-[#171717] shadow-none ring-0 hover:bg-transparent"

export const footerLinkClass =
  "cursor-pointer p-[2px] text-[14px] font-normal leading-5 text-[#4D4D4D] no-underline transition-colors duration-100 hover:text-[#171717] hover:no-underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[oklch(57.61%_0.251_258.23)]"

export const statLabelClass = "text-[16px] font-normal leading-6 text-[#171717]"

export const minorFigureClass =
  "text-[24px] font-normal leading-[32px] tracking-[-0.04em] text-[#171717]"

export const priceFigureClass =
  "text-[56px] font-normal leading-[56px] tracking-[-0.06em] text-[#171717]"

export const priceSuffixClass = "text-[24px] font-normal leading-[32px] text-[#4D4D4D]"

export const metaNoteClass = "text-[14px] font-normal leading-5 text-[#4D4D4D]"

export const heroMetaClass = "text-[14px] font-medium leading-5 text-[#171717]"

export const stepLabelClass = "text-[14px] font-normal leading-5 text-[#4D4D4D]"

export const stepSentenceClass = "text-[20px] font-normal leading-6 text-[#171717]"

export const deploymentLineClass =
  "text-[16px] font-normal leading-6 tracking-[-0.02em] text-[#171717]"

export const logPanelClass = "rounded-[6px] bg-white shadow-[0_0_0_1px_rgba(0,0,0,0.08)]"

export const timerClass = `text-[56px] font-normal leading-[56px] tracking-[-0.06em] text-[#171717] ${sansFamily}`

export const monoClass = `text-[12px] font-normal leading-4 ${monoFamily}`

export const finalBulletClass = `text-[12px] font-normal leading-4 text-[oklch(51.75%_0.145_147.65)] ${monoFamily}`

export const logTimeClass = `${monoClass} text-[#4D4D4D]`

export const logEventClass = `${monoClass} text-[#171717]`
